import { RankProgress, startingRankProgress, addWords } from "./rankprogress";
import { FindPatternGameData } from '../components/findpatterngame';


interface Statistics {
    bestTimes: { [cols: string]: number }
    gamesCompleted: { [cols: string]: number }
    lastTimes: { [cols: string]: number[] }
    wordsFound: number,
    bonusWordsFound: number
}

export interface Profile {
    lastUpdated: number
    stats: Statistics
    rankProgress: RankProgress
}

export function applyCompletedGameToProfile(profile: Profile, gameData:FindPatternGameData): Profile {
    let wordsfound = gameData.foundWords.length;
    let cols = gameData.board.Cols.toString();

    let newCompletedgames:{ [cols: string]: number }  = {}
    newCompletedgames[cols] = (profile.stats.gamesCompleted[cols] || 0) + 1;

    return {
        lastUpdated: Date.now(),
        stats: {
            ...profile.stats,
            gamesCompleted: { ...profile.stats.gamesCompleted, ...newCompletedgames },
            wordsFound: profile.stats.wordsFound + wordsfound
        },
        rankProgress: addWords(profile.rankProgress, wordsfound)
    }
}


export function newProfile(): Profile {
    return {
        lastUpdated: Date.now(),
        rankProgress: startingRankProgress(),
        stats: {
            bestTimes: {},
            gamesCompleted: {},
            lastTimes: {},
            wordsFound: 0,
            bonusWordsFound:0
        }
    }
}


